"use client"

import type { PageContextValue } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import type { FunctionComponent, PropsWithChildren } from "react"

import { useRouter } from "next/navigation"
import { useMemo } from "react"

import { PageContextProvider } from "@/modules/jobSearch/components/PageContext/PageContextProvider"

type InteractiveJobSearchProps = PropsWithChildren<{
  careerCenterConf: PageContextValue["careerCenterConf"]
  careerCenterId: PageContextValue["careerCenterId"]
  careerCenterLogo: PageContextValue["careerCenterLogo"]
  careerCenterMainId: PageContextValue["careerCenterMainId"]
  careerCenterShortName: PageContextValue["careerCenterShortName"]
  currentUserSearchConfig: PageContextValue["currentUserSearchConfig"]
  facets: PageContextValue["facets"]
  hasUserDailyJobOffersAlert: PageContextValue["hasUserDailyJobOffersAlert"]
  isDirectAlgoliaConnectionEnabled: PageContextValue["isDirectAlgoliaConnectionEnabled"]
  isJobAdsFoWoosmapMigrationEnabled: PageContextValue["isJobAdsFoWoosmapMigrationEnabled"]
  isSavedSearchNewJobAdsSinceLastSeenFeatureEnabled: PageContextValue["isSavedSearchNewJobAdsSinceLastSeenFeatureEnabled"]
  isSearchProxyV3ConnectionEnabled: PageContextValue["isSearchProxyV3ConnectionEnabled"]
  isPublicationDateFilterEnabled: PageContextValue["isPublicationDateFilterEnabled"]
  isUserLogged: PageContextValue["isUserLogged"]
  prefilteredSearchParams: PageContextValue["prefilteredSearchParams"]
  savedSearch: PageContextValue["savedSearch"]
  savedSearchSize: PageContextValue["savedSearchSize"]
  trackingContext: PageContextValue["trackingContext"]
}>

export const InteractiveJobSearch: FunctionComponent<InteractiveJobSearchProps> = ({
  careerCenterConf,
  careerCenterId,
  careerCenterLogo,
  careerCenterMainId,
  careerCenterShortName,
  children,
  currentUserSearchConfig,
  facets,
  hasUserDailyJobOffersAlert,
  isDirectAlgoliaConnectionEnabled,
  isJobAdsFoWoosmapMigrationEnabled,
  isSearchProxyV3ConnectionEnabled,
  isSavedSearchNewJobAdsSinceLastSeenFeatureEnabled,
  isPublicationDateFilterEnabled,
  isUserLogged,
  prefilteredSearchParams,
  savedSearch,
  savedSearchSize,
  trackingContext,
}) => {
  const { push } = useRouter()
  const pageContextValue: PageContextValue = useMemo(
    () => ({
      careerCenterConf,
      careerCenterId,
      careerCenterLogo,
      careerCenterMainId,
      careerCenterShortName,
      currentUserSearchConfig,
      facets,
      hasUserDailyJobOffersAlert,
      isDirectAlgoliaConnectionEnabled,
      isJobAdsFoWoosmapMigrationEnabled,
      isPublicationDateFilterEnabled,
      isSavedSearchNewJobAdsSinceLastSeenFeatureEnabled,
      isSearchProxyV3ConnectionEnabled,
      isUserLogged,
      prefilteredSearchParams,
      push,
      savedSearch,
      savedSearchSize,
      trackingContext,
    }),
    [
      careerCenterConf,
      careerCenterId,
      careerCenterLogo,
      careerCenterMainId,
      careerCenterShortName,
      currentUserSearchConfig,
      facets,
      hasUserDailyJobOffersAlert,
      isDirectAlgoliaConnectionEnabled,
      isJobAdsFoWoosmapMigrationEnabled,
      isSavedSearchNewJobAdsSinceLastSeenFeatureEnabled,
      isSearchProxyV3ConnectionEnabled,
      isPublicationDateFilterEnabled,
      isUserLogged,
      prefilteredSearchParams,
      push,
      savedSearch,
      savedSearchSize,
      trackingContext,
    ]
  )

  return <PageContextProvider value={pageContextValue}>{children}</PageContextProvider>
}
